/**
 * Color determinístico y consistente por categoría de ítem de catálogo — el mismo color en
 * todas las pantallas (wizard, detalle de proyecto, catálogo admin). Las primeras 7 entradas
 * calcan los colores fijos del mockup PM_W3_Catalogo_v2.html (--c-fert/-mo/-agro/-plant/-infra/
 * -enmie/-serv); el resto son categorías reales del catálogo que el mockup no cubría, con
 * colores adicionales elegidos para no chocar con esos 7.
 */
const CATEGORIA_COLORS: Record<string, string> = {
  "Fertilizantes": "#0f6e56",
  "Mano de Obra": "#d97706",
  "Agroquímicos": "#dc2626",
  "Plántulas": "#16a34a",
  "Infraestructura": "#2563eb",
  "Enmiendas": "#7c3aed",
  "Servicios": "#6b7280",
  "Actividades de Soporte": "#0ea5e9",
  "Aporte Agricultor": "#ca8a04",
  "Arriendo": "#be185d",
  "Asistencia Técnica": "#4f46e5",
  "Insumos": "#ea580c",
  "Maquinaria": "#92400e",
  "Sistema y Servicio de Riego": "#0891b2",
};

// Para una categoría real que no esté en el mapa fijo -nueva, no prevista arriba-, en vez de
// gris plano cae aquí por hash, para que al menos sea estable entre pantallas.
const FALLBACK_COLORS = ["#0EA5E9", "#8B5CF6", "#E24B4A", "#1d9e75", "#378ADD", "#BA7517"];

export function categoriaColor(categoria: string | null | undefined): string {
  if (!categoria) return "#9e9d98";
  const fijo = CATEGORIA_COLORS[categoria];
  if (fijo) return fijo;
  let hash = 0;
  for (let i = 0; i < categoria.length; i++) hash = (hash * 31 + categoria.charCodeAt(i)) >>> 0;
  return FALLBACK_COLORS[hash % FALLBACK_COLORS.length];
}
